import { render, staticRenderFns } from "./live_shop_promoter_list.vue?vue&type=template&id=69889728"
import script from "./live_shop_promoter_list.vue?vue&type=script&lang=js"
export * from "./live_shop_promoter_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports